import { useEffect } from "react";
import { UseLazyApiCallV2 } from "hooks";
import { getPlatFormType } from "./helpers";
import { platformConversion } from "./constants";
import { UseLazyApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-lazy-api-call";

export function useUserActivityData({
  activeFeature,
  activePlateform,
  activeSportType,
}: {
  [key: string]: string;
}): { [key: string]: any } {
  const [refetch, { data, isLoading }]: any = UseLazyApiCallV2({
    // function should be used to get the url based on sport type
    url: "/analysis_data",
    method: "POST",
    paramsData: {
      platform: getPlatFormType(activePlateform, activeFeature),
      feature: activeFeature,
    },
  });

  const [
    fetchActive,
    { data: usersActiveCount, isLoading: usersActiveLoading },
  ]: any = UseLazyApiCallInternalDashboard({
    url: "active/count",
    method: "POST",
    body: {
      platform: activePlateform,
    },
  });

  const [
    fetchNonActive,
    { data: usersNonActiveCount, isLoading: usersNonActiveLoading },
  ]: any = UseLazyApiCallInternalDashboard({
    url: "nonactive/count",
    method: "POST",
    body: {
      platform: activePlateform,
    },
  });

  const [refetchScan, { data: scanData, isLoading: scanLoading }]: any =
    UseLazyApiCallV2({
      // function should be used to get the url based on sport type
      url: "/analysis_scan",
      method: "POST",
      paramsData: {
        platform: platformConversion[activePlateform] || "",
      },
    });

  const [
    refetchBaseBallAnalysis,
    { data: baseBallAnalysisData, isLoading: baseBallAnalysisLoading },
  ]: any = UseLazyApiCallV2({
    // function should be used to get the url based on sport type
    url: "/baseball_analysis_count",
    method: "POST",
    paramsData: {
      platform: activePlateform === "iOS" ? "IOS" : activePlateform,
    },
  });

  useEffect(() => {
    if (activeSportType === "golf") {
      refetch();
      refetchScan();
      fetchActive();
      fetchNonActive();
    }

    if (activeSportType === "baseball") {
      refetchBaseBallAnalysis();
    }
  }, [activeSportType, activePlateform, activeFeature]);

  const golfUserActivity = {
    data,
    isLoading,
    usersActiveCount,
    usersActiveLoading,
    usersNonActiveCount,
    usersNonActiveLoading,
    scanData,
    scanLoading,
  };

  const baseballUserActivity = {
    baseBallAnalysisData,
    baseBallAnalysisLoading,
  };

  return {
    golfUserActivity,
    baseballUserActivity,
  };
}
